// thumbPath
//  data.id textbook_id
//  data.hash text_image.hash
//  data.extension text_image.extension
const thumbPath = function (data){
    let path = ""
    path = "/images/thumb/" + data.id.toString() + "/" + data.hash + data.extension
    return path
}
export default thumbPath